import { useStore } from '@/utils/vue-api';
import { computed, getCurrentInstance } from 'vue';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useScrollLoad } from '@rebuild/hooks/load-more/useScrollLoad';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useCommonData } from '@/hooks';

export const useCustomCore = (options = {}) => {
	const { moduleId = null } = options;

	const store = useStore();
	const allModules = computed(() => store.getters.getPageAllModules || []);
	const findModule = innerModuleId => {
		const findModule = allModules.value.find(module => module.moduleId === innerModuleId);
		return findModule || {};
	};

	const vm = getCurrentInstance();
	const getRealModuleId = innerModuleId => {
		const queryModuleId = vm.proxy.$route.query.moduleId;
		if (innerModuleId === 'custom') return queryModuleId;
		return innerModuleId || queryModuleId;
	};

	const { viewModule } = useModuleNavigation();

	const handlePreview = info => {
		const findModuleData = findModule(moduleId);
		viewModule('custom', info, findModuleData.name);
	};

	// 内容滚动加载
	const { finalData, hasMoreData, currentPage, pageSize, setData, onPullUp } = useScrollLoad({
		bindChange: loadScrollData
	});

	const { custom } = useModuleData();

	// 统一的数据加载方法
	async function loadScrollData() {
		const params = {
			moduleId: moduleId,
			pageStart: currentPage.value - 1,
			pageNum: pageSize.value
		};

		await custom.refresh(params);
		custom.data?.rows.forEach(item => {
			item.date = new Date(item.contentTime).getTime();
			item.value = item.subject;
		});

		setData(custom.data?.rows || [], custom.data?.total || 0);
	}

	const { getModuleName } = useCommonData();
	const moduleName = computed(() => getModuleName(moduleId));

	return {
		findModule,
		getRealModuleId,
		handlePreview,
		loadScrollData,
		finalData,
		hasMoreData,
		currentPage,
		pageSize,
		setData,
		onPullUp,
		moduleName
	};
};
